import { call, query } from "./calls";

export const DecisionMap = {
    create: (diagramConfig) => call("/ProcessLayout", "POST", diagramConfig),
    update: (diagramConfig) => call(`/ProcessLayout/${diagramConfig.id}`, "PUT", diagramConfig),
    delete: (id) => call(`/ProcessLayout/${id}`, "DELETE"),
    get: (id) => call(`/ProcessLayout/${id}`),
    list: () => query("select * from ProcessLayout where type='decisionMap'")
};